export default {
  sections: {
    title: {
      title: 'Ordine confermato',
      description: 'La tua gift card è stata acquistata con successo',
    },
    instructions: {
      title: 'Controlla la tua email',
      description:
        'Abbiamo inviato i dettagli della gift card e la ricevuta al tuo indirizzo email. Il codice arriverà entro 5-10 minuti.',
    },
    details: {
      total: 'Totale',
      order_number: 'Numero ordine',
    },
    footer: {
      help: "Il nostro partner tecnologico Foodamigos gestisce le gift card. Se non ricevi la gift card o non riesci a trovarla, contattali all'indirizzo {{email}}",
      questions: "Per domande generali sul riscatto, contattaci direttamente all'indirizzo {{email}}",
    },
  },
  buttons: {
    go_home: 'Torna alla home',
    download_pdfs: 'Scarica PDF gift card',
  },
};
